import React, { useId, useState } from 'react'
import { cn } from '../../lib/cn'

/**
 * Tooltip CSS-only accesible (aparece en hover y focus).
 * Envuelve un único hijo enfocable.
 * @param {{ content:React.ReactNode, side?:'top'|'bottom', children:React.ReactNode }} props
 */
export function Tooltip({ content, side = 'top', children, className }) {
  const [open, setOpen] = useState(false)
  const id = useId()

  return (
    <span className="relative inline-flex">
      {React.cloneElement(children, {
        'aria-describedby': open ? id : undefined,
        onMouseEnter: () => setOpen(true),
        onMouseLeave: () => setOpen(false),
        onFocus: () => setOpen(true),
        onBlur: () => setOpen(false),
      })}
      {open && content && (
        <span
          id={id}
          role="tooltip"
          className={cn(
            // Mas cuerpo que antes: texto mas grande y en negrita, y un fondo solido
            // con anillo y sombra para que se lea sobre cualquier cosa que quede detras.
            // w-max: sin esto el globo hereda el ancho del elemento que envuelve y un texto
            // corto queda partido en dos renglones.
            'pointer-events-none absolute left-1/2 z-50 -translate-x-1/2 w-max max-w-[16rem] whitespace-normal text-center leading-snug',
            'rounded-xl bg-slate-900 px-3 py-2 text-[13px] font-semibold text-white',
            'shadow-xl ring-1 ring-white/15 animate-fade-in',
            side === 'top' ? 'bottom-full mb-2' : 'top-full mt-2',
            className
          )}
        >
          {content}
          <span
            aria-hidden="true"
            className={cn(
              'absolute left-1/2 h-2 w-2 -translate-x-1/2 rotate-45 bg-slate-900',
              side === 'top' ? '-bottom-1' : '-top-1'
            )}
          />
        </span>
      )}
    </span>
  )
}

export default Tooltip
